<template>
  <el-input
    ref="rcInput"
    :value="value"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template v-for="slot in slots" :slot="componentSlot(slot)">
      <slot :name="slot"></slot>
    </template>
  </el-input>
</template>

<script>
import { slotMixins } from "../mixins/slotMixins";
export default {
  name: "RcInput",
  mixins: [slotMixins],
  props: {
    value: [String, Number],
    slots: {
      type: Array,
      default: () => ["prefix", "suffix", "prepend", "append"]
    }
  }
};
</script>
